export default {
    PERMISSION_ALL: 'Magespacex_Appadmin::all',

    PERMISSION_CHECK_EXTERNAL_STOCK: 'Magespacex_Webpos::check_external_stock',

    PERMISSION_MANAGE_POS: 'Magespacex_Webpos::manage_pos',

    PERMISSION_REFUND: 'Magespacex_Webpos::refund',

    PERMISSION_MANAGE_SESSION: 'Magespacex_Webpos::manage_session',
    PERMISSION_MAKE_ADJUSTMENT: 'Magespacex_Webpos::make_adjustment',
    PERMISSION_VIEW_SESSIONS_CREATED_BY_OTHER_STAFF: 'Magespacex_Webpos::view_sessions_created_by_other_staff',

    PERMISSION_MANAGE_ORDER: 'Magespacex_Webpos::manage_order',
    PERMISSION_MANAGE_ORDER_CREATED_AT_LOCATION_OF_STAFF: 'Magespacex_Webpos::manage_order_created_at_location_of_staff',
    PERMISSION_MANAGE_ORDER_CREATED_AT_ALL_LOCATION: 'Magespacex_Webpos::manage_order_created_at_all_location',
    PERMISSION_MANAGE_ORDER_THAT_ARE_CREATED_AT_OR_ASSIGNED_TO_LOCATION_OF_STAFF:
        'Magespacex_Webpos::manage_order_that_are_created_at_or_assigned_to_location_of_staff',
    PERMISSION_MANAGE_ALL_ORDERS_IN_SYSTEM: 'Magespacex_Webpos::manage_all_orders_in_system',
    PERMISSION_CUSTOM_PRICE_ON_ITEM: 'Magespacex_Webpos::custom_price_on_item',
}



// WEBPACK FOOTER //
// ./src/view/constant/PermissionConstant.js